"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const svg_components_1 = require("@/assets/svg-components");
const style = __importStar(require("./styled"));
const FavoriteShiptoOption = ({ onSelectOption, displayName, onToggleFavorite, isLast, isLoading, isFavorite }) => {
    return (react_1.default.createElement(style.DropdownListItem, { tabIndex: 0, onKeyDown: e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelectOption();
            }
        }, onClick: onSelectOption, isLast: isLast, isFavorite: isFavorite },
        displayName,
        react_1.default.createElement(style.Star, { onClick: e => {
                e.stopPropagation();
                onToggleFavorite(e);
            }, isFavorite: isFavorite, onKeyDown: e => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    e.stopPropagation();
                    onToggleFavorite(e);
                }
            } }, isLoading ? react_1.default.createElement(style.Spinner, null) : react_1.default.createElement(svg_components_1.StarSmallIcon, null))));
};
exports.default = FavoriteShiptoOption;
